import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ProtectedRoute, { AdminProtectedRoute } from './components/ProtectedRoute';
import { Configurations } from './pages/Configurations';
import { Users } from './pages/Users';
import { Company } from './pages/Company';
import { PetSpace } from './pages/PetSpace';
import { Service } from './pages/Service';
import { CompanyServices } from './pages/CompanyServices';
import { AuthProvider } from './contexts/AuthContext';
import { ConfigStatus } from './pages/ConfigStatus';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { LandingPage } from './pages/LandingPage';
import { TransmissionRooms } from './pages/TransmissionRooms';
import { PublicServiceLive } from './pages/PublicServiceLive';

function App() {

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Navigate to="/landing-page" replace />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/configuracoes"
          element={
            <ProtectedRoute>
              <Configurations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/company"
          element={
            <AdminProtectedRoute>
              <Company />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/petSpace"
          element={
            <ProtectedRoute>
              <PetSpace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/service"
          element={
            <ProtectedRoute>
              <Service />
            </ProtectedRoute>
          }
        />
        <Route
          path="/companyServices"
          element={
            <ProtectedRoute>
              <CompanyServices />
            </ProtectedRoute>
          }
        />

        <Route
          path="/status/config"
          element={
            <ProtectedRoute>
              <ConfigStatus />
            </ProtectedRoute>
          }
        />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/atendimento/:guid" element={<PublicServiceLive />} />
        <Route
          path="/transmission-rooms"
          element={
            <AdminProtectedRoute>
              <TransmissionRooms />
            </AdminProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/landing-page" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;

